import { ApplicationConfig, ErrorHandler, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './login/auth.interceptor';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { environment } from '../environments/environment';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { NGX_ECHARTS_CONFIG } from 'ngx-echarts';
// Añadir estas importaciones
import { provideServiceWorker } from '@angular/service-worker';
import { provideClientHydration } from '@angular/platform-browser';

// Servicios compartidos
import { VideoPlayerService } from './shared/videoplayer/videoplayer.service';
import { NotificationService } from './shared/notification.service';
import { PdfGeneratorService } from './shared/doc-generators/pdf-generator.service';
import { DialogService } from './shared/dialog/dialog.service';
import { IconRegistryService } from './shared/icon-registry.service';
import { provideFirebaseServices } from './core/firebase/firebase-emulator.config';
import { MonitoringErrorHandler } from './shared/monitoring/monitoring-error.handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withViewTransitions()),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor])),
    { provide: ErrorHandler, useClass: MonitoringErrorHandler },
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    ...provideFirebaseServices(),
    provideZonelessChangeDetection(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production
    }),
    provideClientHydration(),
    {
      provide: NGX_ECHARTS_CONFIG,
      useValue: {
        echarts: () => import('echarts')
      }
    },
    // Servicios compartidos
    VideoPlayerService,
    NotificationService,
    PdfGeneratorService,
    DialogService,
    IconRegistryService,
    DecimalPipe,
    CurrencyPipe
  ]
}; 